import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IActivationServiceRequestTemplateModel } from '@apps-common/types/portal/service-request'

export const QUERY_GET_UNIT_ACTIVATION_TEMPLATES = () => ['getUnitActivationTemplates']

export const getUnitActivationTemplates = async (): Promise<IActivationServiceRequestTemplateModel[]> =>
  axios.get(`/UnitActivation/GetActivationTemplates`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitActivationTemplates

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetUnitActivationTemplates = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_ACTIVATION_TEMPLATES(),
    queryFn: () => getUnitActivationTemplates()
  })
